import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Footer() {

 
  return (
    <>

     <div>FOOOOTER</div>

    </>
  );
}

export default Footer;